import { GetServerSideProps } from 'next';
import { getCustomerActivities, getExternalReviews, getFullFaq, getPageData, getPRPosts } from 'api';
import { getCommonOgData, getPageDescription } from "utils/seoFormatters";
import { getCanonicalUrlFromContext } from 'utils/formatters';
import { SignUp } from 'containers/SignUpPage';
import { SimpleItem } from '../../types';

export const getServerSideProps: GetServerSideProps = async (context) => {
  const force = !!context.query.force;
  const email = context.query.email || null
  const [activities, onboarding,  externalReviews = null, prPosts = null, faqTopics] = await Promise.all([
    getCustomerActivities({}, force),
    getPageData('onboarding', force),
    getExternalReviews(),
    getPRPosts(),
    getFullFaq(),
  ]);

  return {
    props: {
      email,
      activities,
      prPosts,
      externalReviews,
      faqTopics,
      onboarding: onboarding?.content || {},
      ogData: getCommonOgData({
        url: getCanonicalUrlFromContext(context),
        title: 'Sign Up | SENDY',
        description: getPageDescription('signUp'),
      }),
    },
  };
};

export default SignUp;
